import { Col, Row, Tooltip } from 'antd'
import Drawer from 'components/Drawer'
import Pagination from 'components/Pagination'
import Select from 'components/Select'
import React, { useState } from 'react'
import RightSideArrowIco from '../../../../src/components/icons/RightSideArrowIco'
import ExpandableTable from '../../../components/UIComponents/ExpandableTable'
import StatusTable from '../../../components/UIComponents/ExpandableTable/StatusTable'
import TableTag from '../../../components/UIComponents/ExpandableTable/TableTag'
import PreviewPage from '../../../components/UIComponents/PreviewScreen'
import DownSideArrowIco from '../../../components/icons/DownSideArrowIco'
import { EmptyDivElement } from '../CommonStyledComponent'
import {
  CompanyText,
  IconStatusSection,
  SortLabel,
  StatusText,
  TableTextSection,
  TextSection,
} from './style'
import EligibilityCriteria from '../../../components/UIComponents/EligibilityCriteria'

const statusBasedObj = status => {
  switch (status) {
    case 'REJECTED':
      return {
        color: '#E35E50',
        bgColor: '#FFF0EE',
        borderColor: 'rgb(227 94 80 / 43%)',
        status: 'Rejected',
      }
    case 'INPROGRESS':
      return {
        color: '#FFB800',
        bgColor: 'rgb(228 155 49 / 13%)',
        borderColor: 'rgb(228 155 49 / 40%)',
        status: 'In Progress',
      }
    case 'APPLIED':
      return {
        color: '#3249D7',
        bgColor: 'rgb(50 73 215 / 14%)',
        borderColor: 'rgb(50 73 215 / 35%)',
        status: 'Applied',
      }
    case 'OFFER_ACCEPTED':
      return {
        color: '#0FB680',
        bgColor: 'rgb(15 182 128 / 14%)',
        borderColor: 'rgb(15 182 128 / 31%)',
        status: 'Offer Accepted',
      }
    case 'OFFER_REJECTED':
    case 'OFFER_DECLINED':
      return {
        color: '#E35E50',
        bgColor: '#FFF0EE',
        borderColor: 'rgb(227 94 80 / 43%)',
        status: 'Offer Declined',
      }
    case 'OFFER_RELEASED':
      return {
        color: '#0FB680',
        bgColor: 'rgb(15 182 128 / 14%)',
        borderColor: 'rgb(15 182 128 / 31%)',
        status: 'Offer Released',
      }
    case 'INTENT_TO_OFFER':
      return {
        color: '#0FB680',
        bgColor: 'rgb(15 182 128 / 14%)',
        borderColor: 'rgb(15 182 128 / 31%)',
        status: 'Intent To Offer',
      }
    case 'ABSENT':
      return {
        color: '#000000',
        bgColor: '#F3F3F3',
        borderColor: '#00000045',
        status: 'Absent',
      }
    case 'SHORTLISTED':
      return {
        status: 'Shortlisted',
      }
    case 'YET_TO_UPDATED':
      return {
        status: 'Yet To Update',
      }
    case 'MISSED':
      return {
        status: 'Missed',
        color: 'rgba(161, 161, 161, 1)',
      }
    case 'INELIGIBLE':
      return {
        status: 'Ineligible',
        color: 'rgba(123, 97, 255, 1)',
      }
    default:
      return {
        color: '#000000',
        bgColor: '#F3F3F3',
        borderColor: '#00000045',
        status: status,
      }
  }
}

const sortByBasedStatus = [
  { value: 'showAll', label: 'Show All' },
  { value: 'APPLIED', label: 'Applied', color: '#3249D7' },
  { value: 'INPROGRESS', label: 'In Progress', color: '#FFB800' },
  { value: 'INTENT_TO_OFFER', label: 'Intent To Offer', color: '#0FB680' },
  { value: 'OFFER_ACCEPTED', label: 'Offer Accepted', color: '#0FB680' },
  { value: 'OFFER_RELEASED', label: 'Offer Released', color: '#0FB680' },
  { value: 'OFFER_REJECTED', label: 'Offer Declined', color: '#E35E50' },
  { value: 'REJECTED', label: 'Rejected', color: '#E35E50' },
  { value: 'ABSENT', label: 'Absent' },
]

const placements = [
  { value: 'showAll', label: 'Show All' },
  { value: 'PLACEMENT', label: 'Placement' },
  { value: 'INTERNSHIP', label: 'Internship' },
  { value: 'GIGS', label: 'Gigs' },
  { value: 'APPRENTICESHIP', label: 'Apprenticeship' },
  { value: 'INTERNSHIP_PPO', label: 'INTERNSHIP_PPO' },
]

export default function PlacementTable({
  title,
  placementHistoryData,
  onPageChange,
  jobCandidateState,
  onFilterChange,
  handleCollapseClick,
  placementHistoryTableLoading,
  getJobRolePreview,
  disabled,
  previewData
}) {
  const [openDrawer, setOpenDrawer] = useState(false)
  const [jobRolePreview, setJobRolePreview] = useState(null)

  const handleDrawerClick = async data => {
    await getJobRolePreview(data?.id)
      .then(response => {
        setJobRolePreview(response?.data?.data)
        setOpenDrawer(true)
      })
      .catch(error => {
        console.error('Error fetching job role preview:', error)
      })
  }

  const handleOnClose = () => {
    setOpenDrawer(false)
  }
  const columns = [
    {
      title: 'Role',
      dataIndex: 'tittle',
      key: 'role',
      render: (text, data) => (
        <Tooltip title={` ${text}`} onClick={() => handleDrawerClick(data)}>
          <div>
            <TextSection
              disabled={disabled}
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                width: '150px',
                cursor: 'pointer',
              }}
            >
              {text}
            </TextSection>
            <TableTag Corp={data?.role_published_by == 'CORPORATE'} />
          </div>
        </Tooltip>
      ),
    },
    {
      title: 'Company Name',
      dataIndex: 'name',
      key: 'name',
      render: text => (
        <Tooltip title={` ${text}`}>
          <CompanyText whiteSpace={text?.length > 16} disabled={disabled}>
            {text}
          </CompanyText>
        </Tooltip>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'evaluationStatus',
      key: 'status',
      width: 230,
      render: (text, data, index) => {
        const status = statusBasedObj(text)
        return (
          <Tooltip>
            <IconStatusSection>
              <StatusText
                color={status?.color}
                status={text}
                disabled={disabled}
              >
                {status?.status}
              </StatusText>
              {/* {(jobCandidateState?.status === 'APPLIED' || jobCandidateState?.status === 'INELIGIBLE') ? ( */}
                <EmptyDivElement
                  onClick={() => handleCollapseClick(data, index)}
                  style={{ cursor: 'pointer' }}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      handleCollapseClick(data, index)
                    }
                  }}
                >
                  {index === jobCandidateState?.collapsedIndex ? (
                    <DownSideArrowIco />
                  ) : (
                    <RightSideArrowIco />
                  )}
                </EmptyDivElement>
              {/* ) : null} */}
            </IconStatusSection>
          </Tooltip>
        )
      },
      isCollapse: true,
    },
  ]

  const renderExpandContent = data => {
    return <StatusTable data={data} />
  }
  const renderExpandContentInEligibility = (data, preview) => {
    return <EligibilityCriteria data={data} previewData={preview || previewData} status={jobCandidateState?.status}/>
  }
  const content = () => {
    return <PreviewPage previewData={jobRolePreview} />
  }

  const collapseCols = [
    {
      title: 'Round Number',
      dataIndex: 'order',
      key: 'order',
      render: (text, data, rowIndex, index) => {
        return index + 1
      },
    },
    {
      title: 'Round Name',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
    },
    {
      title: 'Status',
      dataIndex: 'driveStatus',
      key: 'roundStatus',
      render: text => {
        const status = statusBasedObj(text)
        return <TableTextSection>{status?.status}</TableTextSection>
      },
    },
  ]

  const selectedStatusColor = sortByBasedStatus?.filter(
    item => item?.value == jobCandidateState?.placementStatus
  )[0]

  return (
    <>
      <Row gutter={8} style={{ gap: '10px' }}>
        <Col
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <SortLabel>Filter by </SortLabel>
        </Col>
        {title === 'APPLIED' ? (
          <Col>
            <Select
              OptionData={sortByBasedStatus}
              valueParam="value"
              nameParam="label"
              placeholder="Status"
              placement="bottomLeft"
              allowClear
              onChange={value => onFilterChange(value, 'placementStatus')}
              selectedPlaceId={title + 'placementStatus'}
              width={'160px'}
              value={jobCandidateState?.placementStatus}
              color={selectedStatusColor?.color}
              customHeight={'256px'}
              startFrom={'40px'}
            />
          </Col>
        ) : null}
        <Col>
          <Select
            nameParam={'label'}
            OptionData={placements}
            valueParam="value"
            placeholder="Placement"
            placement="bottomLeft"
            allowClear
            onChange={value => onFilterChange(value, 'placementJobCategory')}
            selectedPlaceId={title + 'placementJobCategory'}
            width={'160px'}
            value={jobCandidateState?.placementJobCategory}
            customHeight={'256px'}
            startFrom={'40px'}
          />
        </Col>
      </Row>

      <Row
        style={{
          paddingTop: 20,
        }}
      >
        <Col xs={24} style={{ maxWidth: '100%', overflow: 'auto' }}>
          <ExpandableTable
            columns={columns}
            data={placementHistoryData?.result || []}
            expandName={'id'}
            renderExpandContent={jobCandidateState?.status === 'INELIGIBLE' || jobCandidateState?.status === 'MISSED' ? renderExpandContentInEligibility : renderExpandContent}
            pagination={false}
            collapseCols={collapseCols}
            handleCollapseClick={handleCollapseClick}
            collapsedData={jobCandidateState?.collapsedData}
            collapsedIndex={jobCandidateState?.collapsedIndex}
            statusBasedObj={statusBasedObj}
            statusStaticStatus={'Evaluation process - To be updated'}
            loading={placementHistoryTableLoading}
            statusProperty="isOpen"
            statusCheck={jobCandidateState?.status == 'MISSED'}
            disabled={disabled}
            inEligible={jobCandidateState?.status === 'INELIGIBLE' || jobCandidateState?.status === 'MISSED'}
            previewData={previewData}
            status={jobCandidateState?.status}
          />
        </Col>
        <Col xs={24} style={{ textAlign: 'center', marginTop: 10 }}>
          <Pagination
            totalPages={placementHistoryData?.count}
            pageSize={placementHistoryData?.limit || 10}
            onChange={onPageChange}
            current={jobCandidateState.placementHistoryPageNo + 1}
          />
        </Col>
      </Row>

      {openDrawer && (
        <Drawer
          width="50%"
          title="Role Preview"
          placement="right"
          visible={openDrawer}
          content={content()}
          onClose={handleOnClose}
          closable={true}
        />
      )}
    </>
  )
}
